import { useState } from 'react';
import axiosService from '../../../../service_v2/common/axios-service';

export const useUpdateEvent = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateEventHook = async (event, handleUpdate) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await axiosService.put(
        `${process.env.REACT_APP_MP_CF_GEN2_API_BASE_URL}qalbox-admin-event-service/v1/update/`,
        {event}
      );

      const json = response?.data;
      if (json?.payload) {
        setSuccess(true);
        handleUpdate(json?.payload);
      } else {
        setError("Failed to update event");
      }
      
    } catch (error) {
      setError("An error occurred while updating the event");
    } finally {
      setLoading(false);
    }
  };

  return [ updateEventHook, loading, error, success ];
};